import { LoadingOutlined } from '@ant-design/icons';
import { OverlayThumb } from 'src/components/OverlayThumb/Loadable';
import { PublicRoute } from 'src/components/RouteGuard';
import { Notfound } from 'src/containers/NotFound/Loadable';
import { Forbidden } from 'src/containers/Forbidden/Loadable';
import { Login } from 'src/containers/Login/Loadable';
import { ForceChangePassword } from 'src/containers/ForceChangePassword/Loadable';
import { Callback } from 'src/containers/Callback/Loadable';
import { CallbackDmdc } from 'src/containers/CallbackDmdc/Loadable';
import { Logout } from 'src/containers/Logout';
import { DefaultLayout } from 'src/layouts/Loadable';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Route,
  Router,
  Switch,
} from 'react-router-dom';
import { GlobalStyle } from 'src/styles/global-styles';
import { history } from 'src/utils/history';
import constants from 'src/constants';
import { AppWrapper } from './styled';
import CheckNewVersion from './components/CheckNewVersion';
import 'src/lang/config';
import { useTranslation } from 'react-i18next';

const App: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet
        titleTemplate="%s - ework"
        defaultTitle={t('title')}
      >
        <meta name="description" content="" />
      </Helmet>

      <CheckNewVersion>
        {(
          loading: any,
          isLatestVersion: any,
          refreshCacheAndReload: any,
        ) => {
          if (loading)
            return (
              <OverlayThumb
                icon={<LoadingOutlined />}
                label="Loading..."
              />
            );
          if (!loading && !isLatestVersion)
            refreshCacheAndReload();
          return (
            <AppWrapper>
              <Router history={history}>
                <Switch>
                  <PublicRoute
                    path={constants.BASE_URL + '/login'}
                    exact
                    component={Login}
                  />
                  <PublicRoute
                    path={constants.BASE_URL + constants.FORCE_CHANGE_PASSWORD_PATH}
                    exact
                    allowWhenAuthenticated
                    component={ForceChangePassword}
                  />
                  <PublicRoute
                    path={constants.BASE_URL + '/callback/dmdc'}
                    exact
                    allowWhenAuthenticated
                    component={CallbackDmdc}
                  />
                  <PublicRoute
                    path={constants.BASE_URL + '/callback'}
                    component={Callback}
                  />
                  <PublicRoute
                    path={constants.BASE_URL + '/loginCallback'}
                    component={Callback}
                  />
                  {/* Không dùng PublicRoute: còn cookie SSO sẽ Redirect "/" và không gọi ssoLogout.
                      Không dùng path /logout: Spring Security default logout 302 → /login?logout. */}
                  <Route
                    path={constants.BASE_URL + '/sso-logout'}
                    exact
                    component={Logout}
                  />
                  <Route
                    path={constants.BASE_URL + '/logout'}
                    exact
                    component={Logout}
                  />
                  {constants.BASE_URL ? (
                    <>
                      <Route path="/sso-logout" exact component={Logout} />
                      <Route path="/logout" exact component={Logout} />
                    </>
                  ) : null}
                  <PublicRoute
                    path={constants.BASE_URL + '/forbidden'}
                    exact
                    component={Forbidden}
                  />
                  <Route
                    path="/"
                    render={props => (
                      <DefaultLayout {...props} />
                    )}
                  />
                  <PublicRoute component={Notfound} />
                </Switch>
              </Router>
            </AppWrapper>
          );
        }}
      </CheckNewVersion>
      <GlobalStyle />
    </>
  );
};

export default App;
